// True if the browser can actually create the WebGL2 context three.js
// needs, not just whether the constructor exists on `window`. Many
// privacy-hardened Firefox setups (privacy.resistFingerprinting,
// webgl.disabled) keep the constructor visible but make getContext()
// return null. We only know by trying.
//
// WebGL2 specifically: three r163+ dropped WebGL1 support, so a browser
// that only offers 'webgl' still throws "Error creating WebGL context."
// inside WebGLRenderer. The old `|| getContext('webgl')` fallback here let
// exactly those browsers through the results-page gate and into a crash.
//
// Result is memoized per session, context creation is expensive on some GPUs
// and the answer is stable for the lifetime of the page.

let cached: boolean | undefined;

export function hasWebGL(): boolean {
  if (cached !== undefined) return cached;
  if (typeof window === 'undefined' || typeof document === 'undefined') {
    return false;
  }
  try {
    const canvas = document.createElement('canvas');
    cached = !!canvas.getContext('webgl2');
  } catch {
    cached = false;
  }
  return cached;
}
